import api from './api'
import { format } from 'date-fns'

export const downloadNfesEstabelecimento = async (id, dateOf, dateUntil) => {
    const dataDe = format(dateOf, 'yyyy-MM-dd')
    const dataAte = format(dateUntil, 'yyyy-MM-dd')
    return await api.get('/api/nfes/download',
        {
            responseType: 'blob',
            params: { dataDe, dataAte },
            headers: { 'X-TenantId': id }
        })
}

export const createNfesEstabelecimentoDownloadJob = async (id, dateOf, dateUntil, idempotencyKey) => {
    const dataDe = format(dateOf, 'yyyy-MM-dd')
    const dataAte = format(dateUntil, 'yyyy-MM-dd')
    return await api.post('/api/nfes/download-jobs', null,
        {
            params: { dataDe, dataAte },
            headers: {
                'X-TenantId': id,
                'Idempotency-Key': idempotencyKey,
            }
        })
}

export const getNfesEstabelecimentoDownloadJob = async (id, jobId) => {
    return await api.get(`/api/nfes/download-jobs/${jobId}`,
        {
            headers: { 'X-TenantId': id }
        })
}

export const downloadNfesEstabelecimentoJob = async (id, jobId) => {
    return await api.get(`/api/nfes/download-jobs/${jobId}/download`,
        {
            responseType: 'blob',
            headers: { 'X-TenantId': id }
        })
}

export const getNfesEstabelecimento = async (id, dateOf, dateUntil, page) => {
    const dataDe = format(dateOf, 'yyyy-MM-dd')
    const dataAte = format(dateUntil, 'yyyy-MM-dd')
    return await api.get('/api/nfes',
        {
            params: { dataDe, dataAte, page },
            headers: { 'X-TenantId': id }
        })
}
